import {outter_post, outter_post_test,post} from 'common/js/axios-helper';
import {TransactionApi} from "./constant/UrlMapper";
import {Loading} from 'element-ui';
import Server from 'common/conf/Server';
import store from 'store';

const host = '8885';
const host4 = '8883';


const memInfoParentInfoList = (data) => {
    return outter_post(TransactionApi.MemInfoParentInfoList, data, host4);
};

const findAllByIdCard = (data) => {
    return outter_post(TransactionApi.FindAllByIdCard, data, host);
};

const merInfoToggle = (data) => {
    return outter_post(TransactionApi.MerInfoToggle, data, host);
};


const merInfoRefresh = (data) => {
    return outter_post(TransactionApi.MerInfoRefresh, data, host);
};

const getProfitDtl = (data) => {
    return outter_post(TransactionApi.GetProfitDtl, data, host);
};

const getRauths = (data) => {
    return outter_post(TransactionApi.GetRauths, data, host);
};

const zhifugetRauths = (data) => {
    return outter_post(TransactionApi.ZhifuGetRauths, data, "9000");
};
const getStatus = (data) => {
    return outter_post(TransactionApi.GetStatus, data, "9000");
};

const getCardCCs = (data) => {
    return outter_post(TransactionApi.GetCardCCs, data, host);
};

const getPlanDtl = (data) => {
    return outter_post(TransactionApi.GetPlanDtl, data, host);
};

const getRepayPlanById = (data) => {
    return outter_post(TransactionApi.GetRepayPlanById, data, host);
};

const selectBalence = (data) => {
    return outter_post(TransactionApi.SelectBalence, data, host);
};

const memCardDelDtl = (data) => {
    return outter_post(TransactionApi.MemCardDelDtl, data, host);
};

const ocrAuthGetList = (data) => {
    return outter_post(TransactionApi.OcrAuthGetList, data, host);
};

const ocrDisable = (data) => {
    return outter_post(TransactionApi.OcrDisable, data, host);
};

const ocrAuthGetDetail = (data) => {
    return outter_post(TransactionApi.OcrAuthGetDetail, data, host);
};

const HbWeizhInfo = (data) => {
    return outter_post(TransactionApi.HbWeizhInfo, data, host);
};

const HbWeizhInfoAgain = (data) => {
    return outter_post(TransactionApi.HbWeizhInfoAgain, data, host);
};

const updatePeopleInfo = (data) => {
    return outter_post(TransactionApi.UpdatePeopleInfo, data, host);
};

const updatePreLicensing = (data) => {
    return outter_post(TransactionApi.UpdatePreLicensing, data, host);
};

//交易查询相关接口->交易管理模块
const transactionmanageList = (data) => {
    return outter_post(TransactionApi.TransactionmanageList, data, host);
};
const TransactionmanageList2 = (data) => {
    return outter_post(TransactionApi.TransactionmanageList2, data, host);
};
const transactionmanageheji = (data) => {
    return outter_post(TransactionApi.TransactionmanageHeji, data, host);
};
const TransactionmanageHeji2 = (data) => {
    return outter_post(TransactionApi.TransactionmanageHeji2, data, host);
};
const settleAccounts = (data) => {
    return outter_post(TransactionApi.settleAccounts, data, host);
};
const settleAccounts2 = (data) => {
    return outter_post(TransactionApi.settleAccounts2, data, host);
};
const settleAccountsOnly = (data) => {
    return outter_post(TransactionApi.settleAccountsOnly, data, host);
};
const settleAccountsOnly2 = (data) => {
    return outter_post(TransactionApi.settleAccountsOnly2, data, host);
};

//代理商分润相关接口->交易管理模块
const agentshareList = (data) => {
    return outter_post(TransactionApi.AgentShareList, data, host);
};
const agentshareAdd = (data) => {
    return outter_post(TransactionApi.AgentShareAdd, data, host);
};

//积分明细相关接口->交易管理模块
const pointsdetailsList = (data) => {
    return outter_post(TransactionApi.PointsDetailsList, data, host);
};
const pointsdetailsheji = (data) => {
    return outter_post(TransactionApi.PointsDetailsHeji, data, host);
};
const pointsdetailsTiaoz = (data) => {
    return outter_post(TransactionApi.PointsDetailsTiaoz, data, host);
};
//欢乐返配置->交易管理模块
const happyreturnmanageList = (data) => {
    return outter_post(TransactionApi.HappyReturnManageList, data, host);
};
const happyreturnmanageEdit = (data) => {
    return outter_post(TransactionApi.HappyReturnManageEdit, data, host);
};
const happyreturnmanageStatus = (data) => {
    return outter_post(TransactionApi.HappyReturnManageStatus, data, host);
};

const twohappyreturnmanageList = (data) => {  //欢乐返配置2.0
    return outter_post(TransactionApi.TwoHappyReturnManageList, data, host);
};
const twohappyreturnmanageEdit = (data) => {
    return outter_post(TransactionApi.TwoHappyReturnManageEdit, data, host);
};
const twohappyreturnmanageAdd = (data) => {
    return outter_post(TransactionApi.TwoHappyReturnManageAdd, data, host);
};
const twohappyreturnmanageStatus = (data) => {
    return outter_post(TransactionApi.TwoHappyReturnManageStatus, data, host);
};

const threehappyreturnmanageAdd = (data) => {  // 新增
    return post(TransactionApi.threehappyreturnmanageAdd, data, host4);
};
const threehappyreturnmanageList = (data) => {  //欢乐返配置2.0
    return post(TransactionApi.ThreeHappyReturnManageList, data, host4);
};
const threehappyreturnmanageEdit = (data) => {
    return post(TransactionApi.ThreeHappyReturnManageEdit, data, host4);
};
const threehappyreturnmanageStatus = (data) => {
    return outter_post(TransactionApi.ThreeHappyReturnManageStatus, data, host);
};

const detailedhappyreturnList = (data) => {
    return outter_post(TransactionApi.DetailedHappyReturnList, data, host);
};

const twodetailedhappyreturnList = (data) => { //欢乐返2考核
    return outter_post(TransactionApi.TwoDetailedHappyReturnList, data, host);
};

const threedetailedhappyreturnlist = (data) => { //欢乐返2考核
    return outter_post(TransactionApi.ThreeDetailedHappyReturnList, data, host);
};
//活跃返配置->交易管理模块
const activereentrymanageList = (data) => {
    return outter_post(TransactionApi.ActiveReentryManageList, data, host);
};
const activereentrymanageEdit = (data) => {
    return outter_post(TransactionApi.ActiveReentryManageEdit, data, host);
};
const activereentrymanageStatus = (data) => {
    return outter_post(TransactionApi.ActiveReentryManageStatus, data, host);
};

const activereentryinfoList = (data) => {
    return outter_post(TransactionApi.ActiveReentryInfoList, data, host);
};
//商户APP管理相关接口
const merchantinfoAdjust = (data) => {
    return outter_post(TransactionApi.merchantinfoAdjust, data, host);
};
const apppointsdetailsList = (data) => {
    return outter_post(TransactionApi.AppPointsDetailsList, data, host);
};
const xjapppointsdetailsList = (data) => {
    return outter_post(TransactionApi.XJAppPointsDetailsList, data, host);
};

const apppointsnewodetojoymanageList = (data) => {    //鼓励金
    return outter_post(TransactionApi.AppPointsNewOdetojoyManageList, data, host);
};
const apppointsnewodetojoymanageEdit = (data) => {
    return outter_post(TransactionApi.AppPointsNewOdetojoyManageEdit, data, host);
};
const apppointsnewodetojoymanageStatus = (data) => {
    return outter_post(TransactionApi.AppPointsNewOdetojoyManageStatus, data, host);
};

const apppointsnewodetoJoyinfoList = (data) => {
    return outter_post(TransactionApi.AppPointsNewOdetojoyInfoList, data, host);
};
const apppointsnewodetoJoyinfoUp = (data) => {
    return outter_post(TransactionApi.AppPointsNewOdetojoyInfoUp, data, host);
};
const apppointsnewodetojoyinfouptwo = (data) => {
    return outter_post(TransactionApi.AppPointsNewOdetojoyInfoUpTwo, data, host);
};
const apppointsnewodetoJoyinfoEdit = (data) => {
    return outter_post(TransactionApi.AppPointsNewOdetojoyInfoEdit, data, host);
};
const apppointsnewodetoJoyinfolookList = (data) => {   //鼓励金明细
    return outter_post(TransactionApi.AppPointsNewOdetojoyInfoLookList, data, host);
};
const apppointsnewodetoJoyinfolookupdate = (data) => {   //鼓励金明细
    return outter_post(TransactionApi.AppPointsNewOdetojoyInfoLookUpdate, data, host);
};

const ysposapppointsnewodetojoymanageList = (data) => {    //银盛pos鼓励金
    return outter_post(TransactionApi.YsPosAppPointsNewOdetojoyManageList, data, host);
};
const ysposapppointsnewodetojoymanageEdit = (data) => {
    return outter_post(TransactionApi.YsPosAppPointsNewOdetojoyManageEdit, data, host);
};
const ysposapppointsnewodetojoymanageStatus = (data) => {
    return outter_post(TransactionApi.YsPosAppPointsNewOdetojoyManageStatus, data, host);
};

const ysposapppointsnewodetoJoyinfoList = (data) => {
    return outter_post(TransactionApi.YsPosAppPointsNewOdetojoyInfoList, data, host);
};
const ysposapppointsnewodetoJoyinfoEdit = (data) => {
    return outter_post(TransactionApi.YsPosAppPointsNewOdetojoyInfoEdit, data, host);
};
const ysposapppointsnewodetoJoyinfolookList = (data) => {   //鼓励金明细
    return outter_post(TransactionApi.YsPosAppPointsNewOdetojoyInfoLookList, data, host);
};

const zxList = (data) => {   //专享鼓励金
    return outter_post(TransactionApi.ZXList, data, "9000");
};
const zxEdit = (data) => {
    return outter_post(TransactionApi.ZXEdit, data, "9000");
};
const zxStatus = (data) => {
    return outter_post(TransactionApi.ZXStatus, data, "9000");
};

const zxinfoList = (data) => {
    return outter_post(TransactionApi.ZXInfoList, data, "9000");
};
const zxinfolookList = (data) => {  //专享鼓励金明细
    return outter_post(TransactionApi.ZXInfoLookList, data, "9000");
};
const zxinfolookupdate = (data) => {
    return outter_post(TransactionApi.ZXInfoLookUpdate, data, "9000");
};

const twoapppointsnewodetojoymanageList = (data) => {    //鼓励金2.0
    return outter_post(TransactionApi.TwoAppPointsNewOdetojoyManageList, data, host);
};
const lklapppointsnewodetojoymanageList = (data) => {    //鼓励金2.0
    return outter_post(TransactionApi.lklAppPointsNewOdetojoyManageList, data, host);
};
const twoapppointsnewodetojoymanageEdit = (data) => {
    return outter_post(TransactionApi.TwoAppPointsNewOdetojoyManageEdit, data, host);
};
const lklapppointsnewodetojoymanageEdit = (data) => {
    return outter_post(TransactionApi.lklAppPointsNewOdetojoyManageEdit, data, host);
};
const twoapppointsnewodetojoymanageStatus = (data) => {
    return outter_post(TransactionApi.TwoAppPointsNewOdetojoyManageStatus, data, host);
};
const lklapppointsnewodetojoymanageStatus = (data) => {
    return outter_post(TransactionApi.lklAppPointsNewOdetojoyManageStatus, data, host);
};

const ThreezxgljEdit = (data) => {
    return outter_post(TransactionApi.ThreezxgljEdit, data, '9000');
};
const ThreezxgljList = (data) => {
    return outter_post(TransactionApi.ThreezxgljList, data, '9000');
};
const zxgljprofitlist = (data) => {
    return outter_post(TransactionApi.ZxgljProfitList, data, '9000');
};
const zxgljprofitedit = (data) => {
    return outter_post(TransactionApi.ZxgljProfitEdit, data, '9000');
};
const zxgljprofitinfo = (data) => {
    return outter_post(TransactionApi.ZxgljProfitInfo, data, '9000');
};
const ThreeapppointsnewodetojoymanageList = (data) => {    //鼓励金2.0
    return outter_post(TransactionApi.ThreeAppPointsNewOdetojoyManageList, data, host);
};
const ThreeapppointsnewodetojoymanageEdit = (data) => {
    return post(TransactionApi.ThreeAppPointsNewOdetojoyManageEdit, data, host);
};
const ThreeapppointsnewodetojoymanageAdd = (data) => {
    return post(TransactionApi.ThreeAppPointsNewOdetojoyManageAdd, data, host);
};
const ThreeapppointsnewodetojoymanageStatus = (data) => {
    return outter_post(TransactionApi.ThreeAppPointsNewOdetojoyManageStatus, data, host);
};

const twoapppointsnewodetoJoyinfoList = (data) => {
    return outter_post(TransactionApi.TwoAppPointsNewOdetojoyInfoList, data, host);
};
const lklapppointsnewodetoJoyinfoList = (data) => {
    return outter_post(TransactionApi.lklAppPointsNewOdetojoyInfoList, data, host);
};
const twoapppointsnewodetoJoyinfoEdit = (data) => {
    return outter_post(TransactionApi.TwoAppPointsNewOdetojoyInfoEdit, data, host);
};
const lklapppointsnewodetoJoyinfoEdit = (data) => {
    return outter_post(TransactionApi.lklAppPointsNewOdetojoyInfoEdit, data, host);
};
const twoapppointsnewodetoJoyinfolookList = (data) => {   //鼓励金明细2.0
    return outter_post(TransactionApi.TwoAppPointsNewOdetojoyInfoLookList, data, host);
};
const lklapppointsnewodetoJoyinfolookList = (data) => {   //鼓励金明细2.0
    return outter_post(TransactionApi.lklAppPointsNewOdetojoyInfoLookList, data, host);
};
const twoapppointsnewodetoJoyinfolookupdate = (data) => {
    return outter_post(TransactionApi.TwoAppPointsNewOdetojoyInfoLookUpdate, data, host);
};
const lklapppointsnewodetoJoyinfolookupdate = (data) => {
    return outter_post(TransactionApi.lklAppPointsNewOdetojoyInfoLookUpdate, data, host);
};

const ThreeapppointsnewodetoJoyinfoList = (data) => {
    return outter_post(TransactionApi.ThreeAppPointsNewOdetojoyInfoList, data, host);
};
const ThreeapppointsnewodetoJoyinfoEdit = (data) => {
    return outter_post(TransactionApi.ThreeAppPointsNewOdetojoyInfoEdit, data, host);
};
const ThreeapppointsnewodetoJoyinfolookList = (data) => {   //鼓励金明细2.0
    return outter_post(TransactionApi.ThreeAppPointsNewOdetojoyInfoLookList, data, host);
};
const ThreeapppointsnewodetoJoyinfolookupdate = (data) => {
    return outter_post(TransactionApi.ThreeAppPointsNewOdetojoyInfoLookUpdate, data, host);
};

const twozxList = (data) => {   //专享鼓励金2.0
    return outter_post(TransactionApi.TwoZXList, data, "9000");
};
const twozxEdit = (data) => {
    return outter_post(TransactionApi.TwoZXEdit, data, "9000");
};
const twozxStatus = (data) => {
    return outter_post(TransactionApi.TwoZXStatus, data, "9000");
};

const ThreezxList = (data) => {   //专享鼓励金2.0
    return outter_post(TransactionApi.ThreeZXList, data, "9000");
};
const ThreezxEdit = (data) => {
    return outter_post(TransactionApi.ThreeZXEdit, data, "9000");
};
const ThreezxStatus = (data) => {
    return outter_post(TransactionApi.ThreeZXStatus, data, "9000");
};

const twozxinfoList = (data) => {
    return outter_post(TransactionApi.TwoZXInfoList, data, "9000");
};

const TwoMoveGlj = (data) => {
    return outter_post(TransactionApi.TwoMoveGlj, data, "9000");
};
const tradeList = (data) => {
    return post(TransactionApi.tradeList, data, '8885');
};
const MoveGlj = (data) => {
    return outter_post(TransactionApi.MoveGlj, data, "9000");
};
const twozxinfolookList = (data) => {  //专享鼓励金明细2.0
    return outter_post(TransactionApi.TwoZXInfoLookList, data, "9000");
};
const twozxinfolookupdate = (data) => {
    return outter_post(TransactionApi.TwoZXInfoLookUpdate, data, "9000");
};

const ThreezxinfoList = (data) => {
    return outter_post(TransactionApi.ThreeZXInfoList, data, "9000");
};
const ThreeMoveGlj = (data) => {
    return outter_post(TransactionApi.ThreeMoveGlj, data, "9000");
};
const ThreezxinfolookList = (data) => {  //专享鼓励金明细2.0
    return outter_post(TransactionApi.ThreeZXInfoLookList, data, "9000");
};
const Threezxinfolookupdate = (data) => {
    return outter_post(TransactionApi.ThreeZXInfoLookUpdate, data, "9000");
};

const apppointstransactionmanageList = (data) => {
    return outter_post(TransactionApi.AppPointsTransactionManageList, data, host);
};
const apppointstransactionmanageEdit = (data) => {
    return outter_post(TransactionApi.AppPointsTransactionManageEdit, data, host);
};
const apppointstransactionmanageInsert = (data) => {
    return outter_post(TransactionApi.AppPointsTransactionManageInsert, data, host);
};
const apppointstransactionmanageStatus = (data) => {
    return outter_post(TransactionApi.AppPointsTransactionManageStatus, data, host);
};
const apppointstransactionmanageDel = (data) => {
    return outter_post(TransactionApi.AppPointsTransactionManageDel, data, host);
};

const merchantgrowthfunddetailsList = (data) => {
    return outter_post(TransactionApi.MerchantGrowthFundDetailsList, data, host);
};

const apppointsagentoperationsList = (data) => {
    return outter_post(TransactionApi.AppPointsagentOperationsList, data, host);
};


//团队奖励配置
const teamrewardsmanageList = (data) => {
    return outter_post(TransactionApi.TeamRewardsManageList, data, "8880");
};
const teamrewardsmanageEdit = (data) => {
    return outter_post(TransactionApi.TeamRewardsManageEdit, data, "8880");
};
const teamrewardsmanageInsert = (data) => {
    return outter_post(TransactionApi.TeamRewardsManageInsert, data, "8880");
};
const teamrewardsmanageDel = (data) => {
    return outter_post(TransactionApi.TeamRewardsManageDel, data, "8880");
};

//团队奖励明细
const teamcomplianceList = (data) => {
    return outter_post(TransactionApi.TeamComplianceList, data, "8880");
};

//团队卓越奖励明细
const teamexcellencemanageList = (data) => {
    return outter_post(TransactionApi.TeamExcellenceManageList, data, "8880");
};
const teamexcellencemanageEdit = (data) => {
    return outter_post(TransactionApi.TeamExcellenceManageEdit, data, "8880");
};
const teamexcellencemanageInsert = (data) => {
    return outter_post(TransactionApi.TeamExcellenceManageInsert, data, "8880");
};
const teamexcellencemanageDel = (data) => {
    return outter_post(TransactionApi.TeamExcellenceManageDel, data, "8880");
};

//商户激活奖励配置
const merchantactivationmanageList = (data) => {
    return outter_post(TransactionApi.MerchantActivationManageList, data, "8880");
};
const merchantactivationmanageUpdate = (data) => {
    return outter_post(TransactionApi.MerchantActivationManageUpdate, data, "8880");
};

//商户激活奖励审核
const merchantactivationexamineList = (data) => {
    return outter_post(TransactionApi.MerchantactivationExamineList, data, "8880");
};
const merchantactivationexamineSh = (data) => {
    return outter_post(TransactionApi.MerchantactivationExamineSh, data, "8880");
};
const merchantactivationexamineTj = (data) => {
    return outter_post(TransactionApi.MerchantactivationExamineTj, data, "8880");
};

//商户活动->优惠卷
//优惠券管理
const couponmanageList = (data) => {
    return outter_post(TransactionApi.CouponManageList, data, host);
};
const couponmanageEdit = (data) => {
    return outter_post(TransactionApi.CouponManageEdit, data, host);
};
const couponmanageInsert = (data) => {
    return outter_post(TransactionApi.CouponManageInsert, data, host);
};
const couponmanageStatus = (data) => {
    return outter_post(TransactionApi.CouponManageStatus, data, host);
};
const couponmanageDel = (data) => {
    return outter_post(TransactionApi.CouponManageDel, data, host);
};
const kycpall = (data) => {
    return outter_post(TransactionApi.KycpAll, data, host);
};
//优惠券组管理->接口
const getRealName = (data) => {
    return outter_post(TransactionApi.GetRealName, data, host);
};
const GetRealNamePrivate = (data) => {
    return outter_post(TransactionApi.GetRealNamePrivate, data, host4);
};
const couponListall = (data) => {
    return outter_post(TransactionApi.CouponListall, data, host);
};
const coupongroupmanageList = (data) => {
    return outter_post(TransactionApi.CouponGroupManageList, data, host);
};
const CouponGroupupdateById = (data) => {
    return outter_post(TransactionApi.CouponGroupupdateById, data, host);
};
const coupongroupmanageDetail = (data) => {
    return outter_post(TransactionApi.CouponGroupManageDetail, data, host);
};
const coupongroupmanageEdit = (data) => {
    return outter_post(TransactionApi.CouponGroupManageEdit, data, host);
};
const coupongroupmanageInsert = (data) => {
    return outter_post(TransactionApi.CouponGroupManageInsert, data, host);
};
const coupongroupmanageDel = (data) => {
    return outter_post(TransactionApi.CouponGroupManageDel, data, host);
};
const coupongroupmanagefafang = (data) => {
    return outter_post(TransactionApi.CouponGroupManageFaFang, data, host);
};
//商户优惠卷查询->接口
const couponmerchantselectList = (data) => {
    return outter_post(TransactionApi.CouponMerchantSelectList, data, host);
};
const couponmerchantselectStatus = (data) => {
    return outter_post(TransactionApi.CouponMerchantSelectStatus, data, host);
};

//优惠券转赠->接口
const couponinfoList = (data) => {
    return outter_post(TransactionApi.CouponInfoList, data, host);
};

//商户签到配置----明细->接口
const apppointssignList = (data) => {
    return outter_post(TransactionApi.AppPointsSignList, data, host);
};
const apppointssignEdit = (data) => {
    return outter_post(TransactionApi.AppPointsSignEdit, data, host);
};
const apppointssignInsert = (data) => {
    return outter_post(TransactionApi.AppPointsSignInsert, data, host);
};
const apppointssignDel = (data) => {
    return outter_post(TransactionApi.AppPointsSignDel, data, host);
};
const apppointssigninfoList = (data) => {
    return outter_post(TransactionApi.AppPointsSignInfoList, data, host);
};
const lklexaminelist = (data) => {
    return outter_post(TransactionApi.LKLExamineList, data, host);
};
const payTypeList = (data) => {
    return outter_post(TransactionApi.payTypeList, data, host);
};
const lkldepositlist = (data) => {
    return outter_post(TransactionApi.LKLDepositList, data, '9000');
};

const lkldepositdtllist = (data) => {
    return outter_post(TransactionApi.LKLDepositDtlList, data, '9000');
};

const addOrUpdateByManage = (data) => {
    return outter_post(TransactionApi.addOrUpdateByManage, data, '9000');
};


export const getUserId = () => {
    return store.getters.userId
};
const addTradeList = (data) => {
    return post(TransactionApi.addTrade, data, '8885');
};
const exportFile = (data) => {

    let loadingInstanceget = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });

    let params = '';

    for (let key in data) {
        params += key + '=' + data[key] + '&';
    }
    // console.log(params)
    window.open(Server[process.env.NODE_ENV] + '8885/ocrAuth/downloadPic' + '?' + params, '_blank');
    loadingInstanceget.close();
};

export default {
    memInfoParentInfoList,

    findAllByIdCard,
    merInfoToggle,
    merInfoRefresh,
    getProfitDtl,
    getRauths,
    zhifugetRauths,
    getStatus,
    getCardCCs,
    getRepayPlanById,
    getPlanDtl,
    selectBalence,
    memCardDelDtl,
    ocrAuthGetList,
    ocrDisable,
    ocrAuthGetDetail,
    exportFile,
    HbWeizhInfo,
    HbWeizhInfoAgain,
    updatePeopleInfo,
    updatePreLicensing,

    transactionmanageList,
    TransactionmanageList2,
    transactionmanageheji,
    TransactionmanageHeji2,
    settleAccounts,
    settleAccounts2,
    settleAccountsOnly,
    settleAccountsOnly2,

    agentshareList,
    agentshareAdd,

    pointsdetailsList,
    pointsdetailsheji,
    pointsdetailsTiaoz,

    merchantinfoAdjust,
    apppointsdetailsList,
    xjapppointsdetailsList,

    apppointsnewodetojoymanageList,
    apppointsnewodetojoymanageEdit,
    apppointsnewodetojoymanageStatus,

    apppointsnewodetoJoyinfoList,
    apppointsnewodetoJoyinfoEdit,
    apppointsnewodetoJoyinfoUp,
    apppointsnewodetojoyinfouptwo,
    apppointsnewodetoJoyinfolookList,
    apppointsnewodetoJoyinfolookupdate,

    ysposapppointsnewodetojoymanageList,
    ysposapppointsnewodetojoymanageEdit,
    ysposapppointsnewodetojoymanageStatus,

    ysposapppointsnewodetoJoyinfoList,
    ysposapppointsnewodetoJoyinfoEdit,
    ysposapppointsnewodetoJoyinfolookList,

    zxList,
    zxEdit,
    zxStatus,

    zxinfoList,
    zxinfolookList,
    zxinfolookupdate,

    twoapppointsnewodetojoymanageList,
    lklapppointsnewodetojoymanageList,
    twoapppointsnewodetojoymanageEdit,
    lklapppointsnewodetojoymanageEdit,
    twoapppointsnewodetojoymanageStatus,
    lklapppointsnewodetojoymanageStatus,

    ThreezxgljEdit,
    ThreezxgljList,
    zxgljprofitlist,
    zxgljprofitedit,
    zxgljprofitinfo,
    ThreeapppointsnewodetojoymanageList,
    ThreeapppointsnewodetojoymanageEdit,
    ThreeapppointsnewodetojoymanageStatus,

    twoapppointsnewodetoJoyinfoList,
    lklapppointsnewodetoJoyinfoList,
    twoapppointsnewodetoJoyinfoEdit,
    lklapppointsnewodetoJoyinfoEdit,
    twoapppointsnewodetoJoyinfolookList,
    lklapppointsnewodetoJoyinfolookList,
    twoapppointsnewodetoJoyinfolookupdate,
    lklapppointsnewodetoJoyinfolookupdate,

    ThreeapppointsnewodetoJoyinfoList,
    ThreeapppointsnewodetoJoyinfoEdit,
    ThreeapppointsnewodetoJoyinfolookList,
    ThreeapppointsnewodetoJoyinfolookupdate,

    twozxList,
    twozxEdit,
    twozxStatus,

    ThreezxList,
    ThreezxEdit,
    ThreezxStatus,

    twozxinfoList,
    TwoMoveGlj,
    MoveGlj,
    twozxinfolookList,
    twozxinfolookupdate,

    ThreeMoveGlj,
    ThreezxinfoList,
    ThreezxinfolookList,
    Threezxinfolookupdate,

    apppointstransactionmanageList,
    apppointstransactionmanageEdit,
    apppointstransactionmanageInsert,
    apppointstransactionmanageStatus,
    apppointstransactionmanageDel,

    merchantgrowthfunddetailsList,

    apppointsagentoperationsList,

    detailedhappyreturnList,
    twohappyreturnmanageAdd,
    twodetailedhappyreturnList,
    threedetailedhappyreturnlist,

    happyreturnmanageList,
    happyreturnmanageEdit,
    happyreturnmanageStatus,

    twohappyreturnmanageList,
    twohappyreturnmanageEdit,
    twohappyreturnmanageStatus,
    threehappyreturnmanageList,
    threehappyreturnmanageAdd,
    threehappyreturnmanageEdit,
    threehappyreturnmanageStatus,

    activereentryinfoList,

    activereentrymanageList,
    activereentrymanageEdit,
    activereentrymanageStatus,

    teamrewardsmanageList,
    teamrewardsmanageEdit,
    teamrewardsmanageInsert,
    teamrewardsmanageDel,

    teamcomplianceList,

    teamexcellencemanageList,
    teamexcellencemanageEdit,
    teamexcellencemanageInsert,
    teamexcellencemanageDel,

    merchantactivationmanageList,
    merchantactivationmanageUpdate,

    merchantactivationexamineList,
    merchantactivationexamineSh,
    merchantactivationexamineTj,

    couponmanageList,
    couponmanageEdit,
    couponmanageInsert,
    couponmanageStatus,
    couponmanageDel,
    kycpall,

    getRealName,
    GetRealNamePrivate,
    couponListall,
    coupongroupmanageList,
    CouponGroupupdateById,
    coupongroupmanageDetail,
    coupongroupmanageEdit,
    coupongroupmanageInsert,
    coupongroupmanageDel,
    coupongroupmanagefafang,

    couponmerchantselectList,
    couponmerchantselectStatus,

    couponinfoList,

    apppointssignList,
    apppointssignEdit,
    apppointssignInsert,
    apppointssignDel,
    apppointssigninfoList,

    payTypeList,
    lklexaminelist,
    lkldepositlist,
    lkldepositdtllist,
    addOrUpdateByManage,
    tradeList,
    addTradeList,
    ThreeapppointsnewodetojoymanageAdd
}



// WEBPACK FOOTER //
// ./src/service/TransactionService.js